<template>
  <div>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="danger" :msg="alert.error" />

    <b-modal
      id="modal-prevent-closing"
      ref="vehicleTypeModal"
      title="Cadastro de Tipo de Equipamento"
      size="lg"
    >
      <div v-if="readOnly">
        <label for="warning" class="warning">
          Você não possui acesso para editar esse tipo de equipamento
        </label>
      </div>

      <b-form-group>
        <label>Nome do equipamento:*</label>
        <b-form-input
          v-model="vehicleType.name"
          type="text"
          placeholder="Tipo do equipamento"
          :disabled="readOnly"
        ></b-form-input>
        <span class="text-danger" v-if="modelstate['Name']">
          {{ modelstate["Name"][0] }}
        </span>
      </b-form-group>

      <b-form-group label="Veículo motorizado:*" label-for="isMotorized">
        <b-form-select
          v-model="vehicleType.isMotorized"
          :options="[
            { value: true, text: 'Sim' },
            { value: false, text: 'Não' },
          ]"
          :disabled="readOnly"
        ></b-form-select>
      </b-form-group>

      <b-form-group v-if="vehicleType.isMotorized">
        <label>Tipo de marcador:*</label>
        <b-form-select
          v-model="vehicleType.markerType"
          :options="markerTypeOpt"
          :disabled="readOnly"
        ></b-form-select>
      </b-form-group>

      <b-form-group v-if="vehicleType.isMotorized">
        <label>Tipo de combustível</label>
        <multiselect
          v-model="vehicleType.fuelTypes"
          :options="fuelTypes"
          :multiple="true"
          label="text"
          track-by="value"
          placeholder="Selecione os tipos de combustível"
          :disabled="readOnly"
          class="mb-3"
        />
      </b-form-group>

      <!-- <pre class="language-json">
        <code>vehicleType: {{ vehicleType  }}</code>
      </pre> -->

      <template #modal-footer="{ cancel }">
        <div class="right">
          <b-button
            v-if="!readOnly"
            class="ml-2"
            variant="green"
            @click="saveVehicle"
          >
            {{ $t("geral.save") }}
          </b-button>
          <b-button class="ml-2" variant="danger" @click="cancel">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "VehicleTypeModal",
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    Multiselect,
  },
  data() {
    return {
      alert: {
        error: "Nome do tipo de equipamento é obrigatório!",
        success: "Tipo de veículo salvo com sucesso!",
      },
      typeId: 0,
      fuelTypes: [],
      vehicleType: {
        name: "",
        markerType: 0,
        active: true,
        isMotorized: false,
        fuelTypes: [],
      },
      readOnly: true,
      markerTypeOpt: [
        { value: 0, text: "Hodômetro" },
        { value: 1, text: "Horímetro" },
      ],
      modelstate: [],
    };
  },
  mounted() {
    this.loadFuelOptions();
  },
  methods: {
    openModal(vehicleTypeId) {
      this.readOnly = true;
      if (vehicleTypeId !== 0) {
        this.typeId = vehicleTypeId;
        this.loadData(vehicleTypeId);
        this.loadFuelOptions();
      } else {
        this.vehicleType = {
          name: "",
          markerType: 0,
          active: true,
          isMotorized: false,
          fuelTypes: [],
        };
        this.readOnly = false;
      }
      this.$refs.vehicleTypeModal.show();
    },
    loadData() {
      this.$apiVehicle
        .get("/vehicleType/getById/" + this.typeId)
        .then((response) => {
          this.vehicleType = response.data;
          this.vehicleType.fuelTypes = this.vehicleType.fuelTypes.map(
            (fuel) => ({
              value: fuel.id,
              text: fuel.name,
            })
          );
          if (this.vehicleType.companyId == null) {
            if (this.$store.getters.companyId == 1) {
              this.readOnly = false;
              this.$forceUpdate();
            }
          } else if (this.vehicleType.companyId != null) {
            this.readOnly = false;
            this.$forceUpdate();
          }
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.$refs.vehicleTypeModal.hide();
            this.$refs.alertError.show();
          }
        });
    },
    loadFuelOptions() {
      this.$apiVehicle
        .get("/fuelType/dropdownList/")
        .then((response) => {
          this.fuelTypes = response.data.map((fuel) => ({
            value: fuel.value,
            text: fuel.text,
          }));
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.$refs.vehicleTypeModal.hide();
            this.$refs.alertError.show();
          }
        });
    },
    saveVehicle() {
      if ((this.vehicleType.fuelTypes?.length ?? 0) > 0) {
        this.vehicleType.fuelTypes = this.vehicleType.fuelTypes.map((item) => ({
          Id: item.value,
          Name: item.text,
        }));
      }

      this.$apiVehicle
        .post("/vehicleType/save", this.vehicleType)
        .then((response) => {
          this.modelstate = [];
          this.$refs.vehicleTypeModal.hide();
          this.vehicleType = {
            name: "",
            markerType: 0,
            active: true,
            isMotorized: false,
            fuelTypes: [],
          };
          this.$emit("refreshTable");
          this.$emit("onSave", response.data.id);
          this.$forceUpdate();
          this.$refs.alert.success.show();
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
            return;
          }
          if (error.response.data == null) {
            this.modelstate = [];
            this.alert.error = error.response.title;
            this.$refs.danger.show();
            return;
          }
          if (error.response.data.errors != null) {
            this.modelstate = error.response.data.errors;
            this.alert.error = error.response.data.title;
            this.$refs.danger.show();
            return;
          }
          if (error.response.data.errorMessage) {
            this.modelstate = [];
            this.alert.error = error.response.data.errorMessage;
            this.$refs.danger.show();
            return;
          }
        });
    },
  },
};
</script>

<style scoped>
.right {
  text-align: right;
  width: 100%;
}
.warning {
  color: rgb(228, 112, 112);
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
